//tabs
document.querySelector('body').addEventListener('click', (e) => {
	const target = e.target.closest('.tabs__btn');
	if (!target) return;

	const tabsRoot = target.closest('.tabs');
	const activeTabs = tabsRoot.querySelector('.tabs__content.is-active');
	const activeBtn = tabsRoot.querySelector('.tabs__btn.is-active');

	if (activeTabs) activeTabs.classList.remove('is-active');
	if (activeBtn) activeBtn.classList.remove('is-active');

	target.classList.add('is-active');
	const newContent = document.querySelector(target.dataset.tabs);
	if (!newContent) return;
	newContent.classList.add('is-active');

	newContent.querySelectorAll('.splide').forEach(el => {
		if (el.splide) el.splide.refresh();
	});
});